export const messages = {
  en: {
    listParkingSpace: {
      queryCondition: "Query Conditions",
      parkingLotPlaceholder: "Please select parking lot",
      select: "Select",
      parkingSpaceNumPlaceholder: "Please enter parking space number",
      parkingSpaceStatePlaceholder: "Required, select parking space state",
      forSale: "For Sale",
      forRent: "For Rent",
      free: "Free",
      query: "Query",
      reset: "Reset",
      parkingSpaceIdPlaceholder: "Please enter parking space ID",
      parkingSpaceInfo: "Parking Space Information",
      batchAdd: "Batch Add",
      add: "Add",
      parkingLot: "Parking Lot",
      parkingSpace: "Parking Space",
      parkingSpaceState: "Parking Space State",
      parkingSpaceType: "Parking Space Type",
      area: "Area",
      createTime: "Create Time",
      operation: "Operation",
      modify: "Modify",
      delete: "Delete"
    },
    addParkingSpace: {
      title: "Add",
      parkingSpaceNum: "Parking Space Number",
      parkingSpaceNumPlaceholder: "Required, enter parking space number",
      parkingLot: "Parking Lot",
      parkingLotPlaceholder: "Required, select parking lot",
      parkingSpaceType: "Parking Space Type",
      parkingSpaceTypePlaceholder: "Required, select parking space type",
      area: "Area",
      areaPlaceholder: "Required, enter area, e.g. 30.09",
      remark: "Remark",
      remarkPlaceholder: "Optional, enter remark",
      save: "Save",
      cancel: "Cancel"
    },
    editParkingSpace: {
      title: "Edit Parking Space",
      parkingSpaceNum: "Parking Space Number",
      parkingSpaceNumPlaceholder: "Required, enter parking space number",
      parkingLot: "Parking Lot",
      parkingLotPlaceholder: "Required, select parking lot",
      parkingSpaceType: "Parking Space Type",
      area: "Area",
      areaPlaceholder: "Required, enter area, e.g. 30.09",
      remark: "Remark",
      remarkPlaceholder: "Optional, enter remark",
      save: "Save",
      cancel: "Cancel"
    },
    deleteParkingSpace: {
      title: "Confirm Operation",
      confirmDelete: "Confirm to delete?",
      cancel: "Cancel",
      confirm: "Confirm Delete"
    },
    chooseParkingArea: {
      title: "Select Parking Lot",
      parkingLotNumPlaceholder: "Enter parking lot number",
      query: "Query",
      reset: "Reset",
      parkingLotId: "Parking Lot ID",
      parkingLotNum: "Parking Lot Number",
      parkingLotType: "Parking Lot Type",
      operation: "Operation",
      select: "Select"
    },
    batchAddParkingSpace: {
      title: "Add",
      prefixNum: "Number Prefix",
      prefixNumPlaceholder: "Optional, prefix letters when not pure numbers, e.g. A for A12",
      startNum: "Start Number",
      startNumPlaceholder: "Required, enter starting number",
      endNum: "End Number",
      endNumPlaceholder: "Required, enter ending number",
      parkingLot: "Parking Lot",
      parkingLotPlaceholder: "Required, select parking lot",
      parkingSpaceType: "Parking Space Type",
      parkingSpaceTypePlaceholder: "Required, select parking space type",
      save: "Save",
      cancel: "Cancel"
    }
  },
  zh: {
    listParkingSpace: {
      queryCondition: "查询条件",
      parkingLotPlaceholder: "请选择停车场",
      select: "选择",
      parkingSpaceNumPlaceholder: "请填写车位编号",
      parkingSpaceStatePlaceholder: "必填，请选择车位状态",
      forSale: "出售",
      forRent: "出租",
      free: "空闲",
      query: "查询",
      reset: "重置",
      parkingSpaceIdPlaceholder: "请填写车位ID",
      parkingSpaceInfo: "停车位信息",
      batchAdd: "批量添加",
      add: "添加",
      parkingLot: "停车场",
      parkingSpace: "车位",
      parkingSpaceState: "车位状态",
      parkingSpaceType: "车位类型",
      area: "面积",
      createTime: "创建时间",
      operation: "操作",
      modify: "修改",
      delete: "删除"
    },
    addParkingSpace: {
      title: "添加",
      parkingSpaceNum: "车位编码",
      parkingSpaceNumPlaceholder: "必填，请填写车位编码",
      parkingLot: "停车场",
      parkingLotPlaceholder: "必填，请选择停车场",
      parkingSpaceType: "车位类型",
      parkingSpaceTypePlaceholder: "必填，请选择车位类型",
      area: "面积",
      areaPlaceholder: "必填，请填写面积，如30.09",
      remark: "备注",
      remarkPlaceholder: "可填，请填写备注",
      save: "保存",
      cancel: "取消"
    },
    editParkingSpace: {
      title: "修改车位",
      parkingSpaceNum: "车位编码",
      parkingSpaceNumPlaceholder: "必填，请填写车位编码",
      parkingLot: "停车场",
      parkingLotPlaceholder: "必填，请选择停车场",
      parkingSpaceType: "车位类型",
      area: "面积",
      areaPlaceholder: "必填，请填写面积，如30.09",
      remark: "备注",
      remarkPlaceholder: "可填，请填写备注",
      save: "保存",
      cancel: "取消"
    },
    deleteParkingSpace: {
      title: "请确认您的操作",
      confirmDelete: "确认是否删除!",
      cancel: "点错了",
      confirm: "确认删除"
    },
    chooseParkingArea: {
      title: "选择停车场",
      parkingLotNumPlaceholder: "输入停车场编号",
      query: "查询",
      reset: "重置",
      parkingLotId: "停车场ID",
      parkingLotNum: "停车场编号",
      parkingLotType: "停车场类型",
      operation: "操作",
      select: "选择"
    },
    batchAddParkingSpace: {
      title: "添加",
      prefixNum: "编号前缀",
      prefixNumPlaceholder: "选填，不是纯数字时前面字母 如A12 时填写A",
      startNum: "开始编号",
      startNumPlaceholder: "必填，请填写编码中数字部分开始编号",
      endNum: "结束编号",
      endNumPlaceholder: "必填，请填写编码中数字部分结束编号",
      parkingLot: "停车场",
      parkingLotPlaceholder: "必填，请选择停车场",
      parkingSpaceType: "车位类型",
parkingSpaceTypePlaceholder: "必填，请选择车位类型",
      save: "保存",
      cancel: "取消"
    }
  },
  'zh-TW': {
    listParkingSpace: {
      queryCondition: "查询条件",
      parkingLotPlaceholder: "请选择停车场",
      select: "选择",
      parkingSpaceNumPlaceholder: "请填写车位编号",
      parkingSpaceStatePlaceholder: "必填，请选择车位状态",
      forSale: "出售",
      forRent: "出租",
      free: "闲置",
      query: "查询",
      reset: "重置",
      parkingSpaceIdPlaceholder: "请填写车位ID",
      parkingSpaceInfo: "停车位信息",
      batchAdd: "批量添加",
      add: "添加",
      parkingLot: "停车场",
      parkingSpace: "车位",
      parkingSpaceState: "车位状态",
      parkingSpaceType: "车位类型",
      area: "面积",
      createTime: "创建时间",
      operation: "操作",
      modify: "修改",
      delete: "删除"
    },
    addParkingSpace: {
      title: "添加",
      parkingSpaceNum: "车位编码",
      parkingSpaceNumPlaceholder: "必填，请填写车位编码",
      parkingLot: "停车场",
      parkingLotPlaceholder: "必填，请选择停车场",
      parkingSpaceType: "车位类型",
      parkingSpaceTypePlaceholder: "必填，请选择车位类型",
      area: "面积",
      areaPlaceholder: "必填，请填写面积，如30.09",
      remark: "备注",
      remarkPlaceholder: "可填，请填写备注",
      save: "保存",
      cancel: "取消"
    },
    editParkingSpace: {
      title: "修改车位",
      parkingSpaceNum: "车位编码",
      parkingSpaceNumPlaceholder: "必填，请填写车位编码",
      parkingLot: "停车场",
      parkingLotPlaceholder: "必填，请选择停车场",
      parkingSpaceType: "车位类型",
      area: "面积",
      areaPlaceholder: "必填，请填写面积，如30.09",
      remark: "备注",
      remarkPlaceholder: "可填，请填写备注",
      save: "保存",
      cancel: "取消"
    },
    deleteParkingSpace: {
      title: "请确认您的操作",
      confirmDelete: "确认是否删除!",
      cancel: "点错了",
      confirm: "确认删除"
    },
    chooseParkingArea: {
      title: "选择停车场",
      parkingLotNumPlaceholder: "输入停车场编号",
      query: "查询",
      reset: "重置",
      parkingLotId: "停车场ID",
      parkingLotNum: "停车场编号",
      parkingLotType: "停车场类型",
      operation: "操作",
      select: "选择"
    },
    batchAddParkingSpace: {
      title: "添加",
      prefixNum: "编号前缀",
      prefixNumPlaceholder: "选填，不是纯数字时前面字母 如A12 时填写A",
      startNum: "开始编号",
      startNumPlaceholder: "必填，请填写编码中数字部分开始编号",
      endNum: "结束编号",
      endNumPlaceholder: "必填，请填写编码中数字部分结束编号",
      parkingLot: "停车场",
      parkingLotPlaceholder: "必填，请选择停车场",
      parkingSpaceType: "车位类型",
      parkingSpaceTypePlaceholder: "必填，请选择车位类型",
      save: "保存",
      cancel: "取消"
    }
  }
}